import React, { useEffect, useState } from "react";
import Input from "../../../Input/input";
import PasswordInput from "../../../Input/passwordInput";

import { registerUser } from "../../../../services/auth";

export default function EmailSignUp({ email, setEmailSignUpActive, onRegisterComplete }) {
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [nameError, setNameError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");

  const resetErrors = () => {
    setNameError("");
    setPasswordError("");
    setConfirmPasswordError("");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    resetErrors();
    if (name === "" || password == "" || confirmPassword === "") {
      name === "" && setNameError("This field cant be empty");
      password === "" && setPasswordError("This field cant be empty");
      confirmPassword === "" && setConfirmPasswordError("This field cant be empty");
      return;
    }
    if (password !== confirmPassword) return setConfirmPasswordError("Password don’t match. Please re-enter the passwords. ");
    handleRegister(name, password);
  };

  const handleRegister = (name, password) => {
    const credentials = {
      email: email.trim() ,
      password: password.trim() ,
      name: name.trim()
    };

    registerUser(credentials, (err, res) => {
      if (res === null) {
        // if (err.response.data.password.length === 1) return setPasswordError('passwords is too common')
        if (err.response.data.password.length === 1) return setPasswordError("Password must be 8 characters long.");
        setPasswordError("passwords is too short");
        return;
      } else {
        // alert("user created");
        resetErrors();
        onRegisterComplete();
      }
    });
  };

  return (
    <div className="form_modal__form email-signup-form mb-4">
      <div className="form_modal__header form_modal__email_signup-header">
        <div className="modal_back_btn icon-button" onClick={() => setEmailSignUpActive(false)}>
          {`<`}
        </div>
        Sign Up With Email
      </div>
      <p className="form_sub_text">Creativity is intelligence having fun!</p>

      <form onSubmit={handleSubmit}>
        <div className="form_modal__form_fields">
          <label className="form-label">Name</label>
          <Input placeholder="Name" value={name} setValue={setName} errorMsg={nameError} />

          <label className="form-label">Set Password</label>
          <PasswordInput placeholder="Set Password" value={password} setValue={setPassword} errorMsg={passwordError} />

          <PasswordInput placeholder="Confirm Password" value={confirmPassword} setValue={setConfirmPassword} errorMsg={confirmPasswordError} />
        </div>

        <button className="form_modal__submit_btn btn-primary">Get Started Now !</button>
      </form>
    </div>
  );
}
